import React from "react";
//css & images
import "./CheckStatus.css";
import greenTick from "../Images/tick-icon.png";
import copyIcon from "../Images/copy-icon.svg";
import whiteCheckmark from "../Images/checkmark-white.svg";
//import loader from "../Images/";
//components
import Breadcrumbs from "../Components/Breadcrumbs";
//functions
import getCookieParam from "../Functions/getCookieParam";
import { showToaster } from "../Components/Toaster";
import apiComponents from "../Functions/apiComponents";
import formResponse from "../Functions/formResponse";
import patchStepCount from "../Functions/patchStepCount";
//import { keyboard } from "@testing-library/user-event/dist/keyboard";

const CheckStatus = () => {
    if (getCookieParam('token') === '') window.location.pathname = `/${getCookieParam('partnerName')}`;     //redirect if login token doesn't exist
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('client') && urlParams.get('channels')) {
        patchStepCount(3, 10, 10, 70);  //update step count in DB
        let clientId = urlParams.get('client');
        let channelId = decodeURI(urlParams.get('channels')).slice(1, -1);
        // api call to get API KEY
        fetch(apiComponents.apiKey, {
            headers: {
                'Authorization': "Bearer " + getCookieParam('token'),
                'content-type': 'application/json',
                'accept': 'application/json',
                'partnerName': getCookieParam('partnerName')
            },
            method: "POST",
            body: JSON.stringify({
                clientId: clientId,
                channelId: channelId,
                email: localStorage.getItem('email')
            })
        }).then(async res => {
            if (await formResponse(res)) {
                res.json().then(data => {
                    document.getElementById('apiKeyInput').value = data.api_key;
                    patchStepCount(3, 10, 10, 80);  //update step count in DB
                    fetch(apiComponents.channels, {
                        headers: {
                            'Authorization': "Bearer " + getCookieParam('token'),
                            'content-type': 'application/json',
                            'accept': 'application/json',
                            'partnerName': getCookieParam('partnerName')
                        },
                        method: "POST",
                        body: JSON.stringify({
                            clientId: clientId,
                            channelId: channelId,
                            email: localStorage.getItem('email'),
                            onboardingUrl: window.location.href
                        })
                    }).then(async res => {
                        if (await formResponse(res)) {
                            res.json().then(data => {
                                if (data.partner_channels[0].status === "permission_granted") {
                                    document.getElementById('check1').style.backgroundColor = "#25D366";
                                    document.getElementById('check1').style.backgroundImage = `url(` + whiteCheckmark + `)`;
                                    document.getElementById('check1').style.backgroundSize = "10px";
                                    patchStepCount(3, 10, 10, 85);  //update step count in DB
                                }
                                if (data.partner_channels[0].waba_account.on_behalf_of_business_info?.status === "approved" ? true : false) {
                                    document.getElementById('check2').style.backgroundColor = "#25D366";
                                    document.getElementById('check2').style.backgroundImage = `url(` + whiteCheckmark + `)`;
                                    document.getElementById('check2').style.backgroundSize = "10px";
                                    patchStepCount(3, 10, 10, 90);  //update step count in DB
                                }
                                if (data.partner_channels[0].waba_account.fb_account_status !== "unknown") {
                                    document.getElementById('check3').style.backgroundColor = "#25D366";
                                    document.getElementById('check3').style.backgroundImage = `url(` + whiteCheckmark + `)`;
                                    document.getElementById('check3').style.backgroundSize = "10px";
                                    patchStepCount(3, 10, 10, 95);  //update step count in DB
                                }
                                if (data.partner_channels[0].waba_account.fb_account_status === "verified") {
                                    document.getElementById('check4').style.backgroundColor = "#25D366";
                                    document.getElementById('check4').style.backgroundImage = `url(` + whiteCheckmark + `)`;
                                    document.getElementById('check4').style.backgroundSize = "10px";
                                    patchStepCount(3, 10, 10, 100);  //update step count in DB
                                }
                                showToaster('', 'Updated!', 'Account status synced');
                            });
                        }
                    });
                });
            }
        });
    }
    //copy API key from input field
    const copyApiKey = async (e) => {
        let btn = e.currentTarget;
        await navigator.clipboard.writeText(btn.previousSibling.value);
        btn.src = greenTick;
        setTimeout(() => { btn.src = copyIcon; }, 1000);
    };
    return (
        <>
            <Breadcrumbs />
            <h2 className="secondary-heading" style={{ margin: "48px 0 -24px 0" }}>
                Kindly wait while we fetch the latest status of your account from<br />WhatsApp and Facebook Business Manager…
            </h2>
            <div className="cs-container">
                <div className="cs-div">
                    <div className="cs-display-check" id="check1"></div>
                    <div style={{ paddingTop: "2px" }}>Number setup</div>
                </div>
                <div className="cs-div">
                    <div className="cs-display-check" id="check2"></div>
                    <div style={{ paddingTop: "2px" }}>Display name approval</div>
                </div>
                <div className="cs-div">
                    <div className="cs-display-check" id="check3"></div>
                    <div style={{ paddingTop: "2px" }}>Facebook Business Manager connected</div>
                </div>
                <div className="cs-div">
                    <div className="cs-display-check" id="check4"></div>
                    <div style={{ paddingTop: "2px" }}>Facebook Business Manager verification</div>
                </div>
            </div>
            <div className="api-key-div">
                API Key
                <input disabled={true} id="apiKeyInput" value={'--'} />
                <img src={copyIcon} alt="copy button" onClick={event => copyApiKey(event)} />
                <div className="api-key-help-text" style={{ display: "none" }}>
                    Copy and paste the above API Key in your <a className="link" href="https://app.engati.com/admin/configure/deployment/whatsapp" target="_blank" rel="noopener noreferrer">Engati account</a> to deploy<br />WhatsApp as a channel. <a className="link" href="https://help.engati.com/whatsapp-setup-using-360dialog" target="_blank" rel="noopener noreferrer">Click here</a> to know more
                </div>
            </div>
            {/* <div className="loader">
                <img src={loader} alt="loader" />
            </div> */}
        </>
    );
}

export default CheckStatus;